import React, { useCallback } from "react";

interface mountedState {
  getMounted: () => boolean;
}

function useMountedState(): mountedState {
  const mounted = React.useRef(true);
  React.useEffect(() => {
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const getMounted = useCallback(() => {
    return mounted.current;
  }, []);

  return { getMounted: getMounted };
}

export default useMountedState;
